




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Steps extends Vue {
  @Prop({ default: 1 })
  public currentStep!: number;

  public get labels() {
    return [
      `${this.$t('page_title.choose_plan')}`,
      `${this.$t('page_title.payment_details')}`,
      `${this.$t('page_title.confirm')}`,
    ];
  }
}
